import { render, staticRenderFns } from "./pageCompoments.vue?vue&type=template&id=670de760&scoped=true&"
import script from "./pageCompoments.vue?vue&type=script&lang=js&"
export * from "./pageCompoments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670de760",
  null
  
)

export default component.exports